import { useEffect } from 'react'
import { useParams } from '../Providers/ParamsProvider'
import LoadingSpinner from './Components/LoadingSpinner'
import { Licenses } from '../Data/Licenses.ts'

const MainThemeStylePicker = () => {
    const { license, handleGetLicense } = useParams()

    useEffect(() => {
        handleGetLicense()
    }, [])

    useEffect(() => {
        if (license) {
            let styleName = ''
            switch (license) {
                case Licenses.Ferrodo:
                    styleName = 'FerrodoMainStyle.css'
                    break
                case Licenses.TgInstalacje:
                    styleName = 'TgMainStyle.css'
                    break
                case Licenses.Hydraulik:
                    styleName = 'HydraulikMainStyle.css'
                    break
            }

            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = `${process.env.PUBLIC_URL}/MainStyles/${styleName}`
            document.head.appendChild(link)

            return () => {
                document.head.removeChild(link)
            }
        }
    }, [license])

    if (license == '' || license.trim() == '') {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 9999,
                    backgroundColor: 'white'
                }}>
                <LoadingSpinner fullScreenLoading={true} loadingText='Ładowanie motywu aplikacji...' />
            </div>
        )
    }
}

export default MainThemeStylePicker